/* @flow */

import type { Tools } from './Common';
import { GridWidth, GridHeight, FloorHeight } from './Common';
import GlobalManager from './GlobalManager';
import Surface from './Surface';

export default class FloorSurface extends Surface {
  constructor() {
    super(
      {
        x: GridWidth / 2,
        y: FloorHeight,
      },
      0,
      GridWidth
    );
    GlobalManager.canvas.subscribeFloor(tools => this.draw(tools));
  }
  draw(tools: Tools) {
    tools.ctx.fillStyle = '#555555';
    tools.ctx.fillRect(0, GridHeight - FloorHeight, GridWidth, FloorHeight);
  }
}



// WEBPACK FOOTER //
// ./src/FloorSurface.js